import {Component} from "react";
import * as React from "react";

class BoxedText extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        return <div className={"boxed-text"}>
            {this.props.text}
        </div>
    }
}

export {BoxedText}